export default "__VITE_ASSET__vAfPf30U__"